import { render } from "./DocumentNavigationAttachment.vue?vue&type=template&id=c1f01744&scoped=true"
import script from "./DocumentNavigationAttachment.vue?vue&type=script&lang=js"
export * from "./DocumentNavigationAttachment.vue?vue&type=script&lang=js"

import "./DocumentNavigationAttachment.vue?vue&type=style&index=0&id=c1f01744&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1f01744"]])

export default __exports__